import React from 'react';

import BooleanDisplay from 'components/BooleanDisplay';

export const filterableBooleanCell = {
  Cell: props => {
    const {value} = props;
    return <BooleanDisplay value={value} />;
  },
  filterMethod: (filter, row) => {
    if (filter.value === 'all') {
      return true;
    }
    if (filter.value === 'true') {
      return row[filter.id];
    }
    return !row[filter.id];
  },
  Filter: ({filter, onChange}) => (
    <select
      onChange={event => onChange(event.target.value)}
      style={{width: '100%'}}
      value={filter ? filter.value : 'all'}
    >
      <option value="">Show All</option>
      <option value="true">Yes</option>
      <option value="false">No</option>
    </select>
  )
};

export const includesInsensitive = (str, search) => {
  return str.toLowerCase().includes(search.toLowerCase());
}

export const defaultFilterMethod = (filter, row) => {
  const id = filter.pivotId || filter.id
  return row[id] !== undefined ? includesInsensitive(String(row[id]),filter.value) : true
}



// WEBPACK FOOTER //
// ./src/utils/table.js